import React, { useState } from 'react';
import { useCampaignDetail } from '../CampaignDetailProvider';
import ButtonComponent from '../../../../../common-components/ButtonComponent/ButtonComponent';
import FilterIcon from '../../../../../Icons/icons/FilterIcon';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Popover } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import '../../../styles/filter.scss'
import CheckTick from '../../../../../Icons/icons/CheckTick';
import { allContentTypeOptions } from './ContentTypeSelect';

export const usageRightsStatusOptions = [
  {
    value: 'pending',
    text: 'Request Sent',
    dotColor: 'var(--blue-b-700)',
    backgroundColor: 'var(--blue-b-50)'
  },
  {
    value: 'negotiation',
    text: 'Negotiation',
    dotColor: 'var(--yellow-y-600)',
    backgroundColor: 'var(--yellow-y-50)'
  },
  {
    value: 'accepted',
    text: 'Approved',
    dotColor: 'var(--success-g-600)',
    backgroundColor: 'var(--success-g-50)'
  },
  {
    value: 'rejected',
    text: 'Rejected',
    dotColor: 'var(--critical-r-500)',
    backgroundColor: 'var(--secondary-surface-red)'
  },
]

const UsageRightsHeader = () => {
  const {
    usageRightsContentType,
    usageRightsStatus,
    setNewUsageRequestsContentType,
    setNewUsageRequestsStatus
  } = useCampaignDetail();

  const [anchorEl, setAnchorEl] = useState(false);
  const open = Boolean(anchorEl);

  function renderSummary(text) {
    return (
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        style={{ borderBottom: '1px solid var(--border-default)' }}
      >
        <div style={{ fontSize: '15px' }}>{text}</div>
      </AccordionSummary>
    );
  }
  
  function renderDetail(child) {
    return <AccordionDetails style={{padding: '10px', borderBottom: '1px solid var(--border-default)'}}>
      {child}
    </AccordionDetails>
  }

  return (
    <div className="sl-content-header-section">
      <Popover
        open={open}
        onClose={() => {
          setAnchorEl(null);
        }}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <div style={{ width: '254px' }}>
          <Accordion>
            {renderSummary('Filter By Status')}
            {renderDetail(<>
              {usageRightsStatusOptions.map((option) => {
              const isSelected = usageRightsStatus === option.value;
              return (
                <div
                  key={option.value}
                  className={`content-type-drop-down-option ${
                    isSelected ? 'content-type-drop-down-option-selected' : ''
                  }`}
                  onClick={() => {
                    if (isSelected) setNewUsageRequestsStatus('all');
                    else setNewUsageRequestsStatus(option.value);
                  }}
                  style={{
                    background: isSelected ? option.backgroundColor : '',
                    borderRadius: '8px'
                  }}
                >
                  <div>
                    <div style={{ background: option.dotColor, width: '4px', height: '4px', borderRadius: '50px' }}/>
                    {option.text}
                  </div>
                </div>
              );
            })}
            </>)}
          </Accordion>
          <Accordion>
            {renderSummary('Filter By Content')}
            {renderDetail(<>
              {allContentTypeOptions.map((option) => {
              const isSelected = usageRightsContentType === option.value;
              return (
                <div
                  key={option.value}
                  className={`content-type-drop-down-option ${
                    isSelected ? 'content-type-drop-down-option-selected' : ''
                  }`}
                  onClick={() => {
                    if (isSelected) setNewUsageRequestsContentType('all');
                    else setNewUsageRequestsContentType(option.value);
                  }}
                >
                  <div>
                    {option.logo}
                    {option.text}
                  </div>
                  {isSelected && <CheckTick color="var(--purple-p-400)" />}
                </div>
              );
            })}
            </>)}
          </Accordion>
        </div>
      </Popover>
      <ButtonComponent
        variant="secondary-outline"
        style={{ padding: '5px', paddingRight: '11px' }}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <FilterIcon color="var(--text-default)" showCircle={false} />
        <div style={{ color: 'var(--text-default)' }}>Filters</div>

        <KeyboardArrowDownIcon
          style={{ transform: `rotate(${open ? 180 : 0}deg)` }}
        />
      </ButtonComponent>
    </div>
  );
};

export default UsageRightsHeader;
